import { Component, OnInit } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { LookupService } from '../../lookup.service';
import { State } from '../../app.constants';
import { TitleVIDataEntryService } from '../../TitleVI/titleVIDataEntry.service'
import { ClaimService } from '../../shared/claim.service';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import * as moment from 'moment';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'oaaps-dashboards',
  templateUrl: 'OaapsTitleVIDashboards.component.html',
  styleUrls: ['./OaapsTitleVIDashboards.component.scss']
})
export class OaapsTitleVIDashboardsComponent implements OnInit {
  selctedMenuNav: any = { mainNav: "nutritionServices", subNav: { pageTitle: "Nutrition Services", menu: 'Total number of Congregate Meals served.', title: 'Congregate Meals', selectedSubMenu: 'TotalCongMeals', subTitle: 'Total number of Congregate Meals served.' } };
  pageTitle: string = '';
  Chart: Chart;
  granteeId: string = ''
  graphData: any = [];
  currentYear: string = '';
  hasCurrentYearReported: boolean = false;
  selectedField: string = '';
  kpiNumbers: string = '';
  kpiPercentage: string = '';
  YAxisLabel: string = '';
  lastDataRefreshDate: string = '';
  isACLUser: boolean = false;
  showvarianceWarning: boolean = false;
  constructor(public _service: TitleVIDataEntryService,public _claimService: ClaimService) {

  }

  ngOnInit(): void {
    this.lastDataRefreshDate = '';
    this.isACLUser = this._claimService.isACLUser();
    if (this.granteeId.length > 0) {
      this._service.getDashboardData(this.selctedMenuNav.subNav.mapping, this.selctedMenuNav.subNav.selectedSubMenu, this.granteeId).subscribe((data) => {
        if (data && data.length != 0) {
          this.graphData = data[0].data;
          this.lastDataRefreshDate = moment(data[0].lastExtractTime).format('MM/DD/yyyy hh:mm a');
          this.showvarianceWarning = false;
          this.plotGraph();
          
        } else if (data.length == 0) {
          this.Chart = new Chart({
            chart: {
              borderColor: '#eee',
              borderRadius: 0,
              borderWidth: 2,
              height: 400,
              width:800,
              marginTop: 50,
              type: 'spline'
            },
            title: {
              text: 'No Data Available',
              align:'center',
              style: {
                fontWeight: 'bold',
                fontSize: '20px',
                color: '#10518D',
              type: 'spline'
            }},
            subtitle: {
              text: ''
            },
            lang: {
              noData: 'No Data Available'
          },
          noData: {
              style: {
                  fontWeight: 'bold',
                  fontSize: '15px',
                  color: '#10518D'
              }
          }
          });
        }
      });
    }
  }

  selctedMenu(menu: any) {
    this.selctedMenuNav = menu;
    this.ngOnInit();
  }

  selectedState(state) {
    this.granteeId = state;
    this.ngOnInit();
  }

  plotGraph() {
    this.currentYear = this.graphData.currentYear;
    let xAxisCategories = [];
    this.hasCurrentYearReported = this.graphData.hasCurrentYearData;
    this.graphData.graphPoints.forEach(year => {
      xAxisCategories.push(year[0]);
    })
    if (this.graphData.elementType && this.graphData.elementType == 'Persons' ) {
      this.YAxisLabel = "Person(s)"
    } else if (this.graphData.elementType && this.graphData.elementType == 'Units' ) {
      this.YAxisLabel = "Unit(s)"
    } else if (this.graphData.elementType && this.graphData.elementType == '' ) {
      this.YAxisLabel = "Meal(s)"
    }
    this.Chart = new Chart({
      chart: {
        borderColor: '#eee',
        borderRadius: 0,
        borderWidth: 2,
        height: 400,
        width:800,
        marginTop: 50,
        type: 'spline'
      },
      legend: {
        enabled: false
    },
      credits: {
        enabled: false,
      },
      title: {
        text: '',
      //   align:'right',
      //   style: {
      //     fontWeight: 'bold',
      //     fontSize: '15px',
      //     color: '#10518D'
      // }
      },
      subtitle: {
        text: ''
      },
      xAxis: {
        crosshair: true,
        labels: { style: { fontSize: "15" } },
        categories: xAxisCategories,
        title: {
          text: 'Years',
          style: {
            fontSize: '15px',
            fontWeight: 'bold',
          }
        }
      },
      yAxis: {
        crosshair: true,
        labels: { style: { fontSize: "15" } },
        title: {
          text: this.YAxisLabel,
          style: {
            fontSize: '15px',
            fontWeight: 'bold',
          }
        }
      },
      plotOptions: {
        spline: {
          dataLabels: {
            enabled: true,
            formatter : function() {
              let unit = this.series.yAxis.options.title.text;
              return Highcharts.numberFormat(this.y,0,'.',',') +' ' + unit
            },
            style: {
              fontSize: '15px',
              fontWeight: 'bold'
            }
          }
        },
        series: {
          label: {
            enabled: false
          },
          lineWidth: 2,
          color: '#10518D',
        }
      },
      
    tooltip: {
      enabled: false
  },
    });

    this.fromatData(this.graphData.graphPoints)
  }

  fromatData(graphData) {
    let points = [];

    graphData.forEach(year => {
      if (!this.hasCurrentYearReported && year[0] == this.currentYear) {
        points.push(null)
      } else {
        points.push(year[1])
      }
    })
    this.Chart.addSeries({ type: 'spline', data: points, name: '' }, true, false);
    this.calculateKpiNumbers();
  }

  calculateKpiNumbers() {
    if (this.hasCurrentYearReported) {
      this.kpiNumbers = this.addComma((this.graphData.graphPoints.find(x => x[0] == this.currentYear)[1]).toString());
      this.kpiPercentage = this.graphData.variancePercentagePoints.find(x => x[0] == this.currentYear)[1] + '%';
      if (parseInt(this.kpiPercentage) >=30) {
        this.showvarianceWarning = true;
        
      } else {
        this.showvarianceWarning = false;
      }
    } else {
      this.kpiNumbers = 'N/A';
      this.kpiPercentage = 'N/A'
      this.YAxisLabel = ''
    }
  }

  addComma(currentValue: string): string {
    const originalvalue = currentValue;
    if (currentValue == null || currentValue === '') {
      return '';
    }
    currentValue = currentValue.replace(/,/g, '');
    const num = parseInt(currentValue);
    if (!isNaN(num) && !currentValue.includes('.')) {
      return currentValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      return originalvalue;
    }
  }
}